module.exports = __webpack_public_path__ + "static/media/ETH.7f324a65.png";